import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router';
import { useSession } from '../lib/session.tsx';

/**
 * The attendee shell.
 *
 * Deliberately light: an attendee has one or two things to do, and every extra
 * navigation item is one more thing to read on a phone at a venue entrance.
 */
export function Chrome({ children }: { readonly children: ReactNode }) {
  const { state, signOut } = useSession();

  return (
    <div className="gc-app">
      <header className="gc-header">
        <div className="gc-container gc-header__inner">
          <Link to="/" className="gc-wordmark">
            Gate<span className="gc-wordmark__accent">Check</span>
          </Link>
          <nav className="gc-attendee-nav" aria-label="Main">
            <NavLink to="/" end className="gc-nav__link">
              Discover
            </NavLink>
            {state.status === 'authenticated' ? (
              <>
                <NavLink to="/orders" className="gc-nav__link">
                  Orders
                </NavLink>
                <NavLink to="/tickets" className="gc-nav__link">
                  My tickets
                </NavLink>
                <NavLink to="/account" className="gc-nav__link">
                  Account
                </NavLink>
                <button className="gc-button gc-button--quiet" onClick={() => void signOut()}>
                  Sign out
                </button>
              </>
            ) : (
              <Link to="/sign-in" className="gc-button gc-button--primary">
                Sign in
              </Link>
            )}
          </nav>
        </div>
      </header>

      {children}

      <footer className="gc-footer">
        <div className="gc-container gc-stack gc-stack--tight">
          <span>GateCheck by CABS</span>
          <span>
            Tickets are ownership records, not images. Presenting a screenshot of someone
            else&rsquo;s ticket will not get anyone through a gate.
          </span>
        </div>
      </footer>
    </div>
  );
}
